import CookieService from "encrypted-cookie";

export const createCookieA = (
  name,
  value,
  days,
) => {
  let expires
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  } else {
    expires = ''
  }
  document.cookie = `${name}=${value} ${expires};path=/`
}

// export const readCookie = (name) => {
//   const nameEQ = `${name}=`
//   const ca = document.cookie.split(';')
//   // eslint-disable-next-line no-plusplus
//   for (let i = 0; i < ca.length; i++) {
//     let c = ca[i]
//     while (c.charAt(0) === ' ') c = c.substring(1, c.length)
//     if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
//   }
//   return null
// }



// export const createAuthCookie = (
//   name,
//   value,
//   days,
// ) => {
//   let expires
//   if (days) {
//     const date = new Date()
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
//     expires = `; expires=${date.toUTCString()}`
//   } else {
//     expires = ''
//   }
//   document.cookie = `${name}=${value} ${expires};path=/`
// }

// updated code
export const createAuthCookie = (name, value, days) => {
  if (!name || !value || typeof days !== 'number') {
    // Check for valid parameters and handle errors appropriately.
    console.error('Invalid parameters for creating a cookie.');
    return;
  }

  let expires = '';
  if (days > 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${value}${expires}; path=/`;
};

export const readAuthCookie = (name) => {
  // return CookieService.getCookie(name)

  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export const createCookie = (
  name,
  value,
  days,
) => {
  CookieService.setCookie(name, value, 1, "aaa");
}

export const readCookie = (name) => {
  return CookieService.getCookie(name, "aaa")
}

// CookieService.setCookie("userName", "Bavaram", 7,"aaa");
// console.log(CookieService.getCookie("userName","aaa"));

export const eraseCookie = (name) => {
  cookieStore.delete("role");
  cookieStore.delete("user_name");

  createCookieA(name, '', -1)
}
